import { Box } from '@material-ui/core';
import { Ticketing } from '@nemuru-eng/js-api-client';
import { useEffect, useState } from 'react';

import { Font } from '@/components/shared/components/Font';
import { PendingDataWarning } from '@/components/shared/components/PendingDataWarning';
import { Text } from '@/components/shared/components/Text';
import { ActivityLogCard } from '@/components/widgets/CustomerSupport/components/CustomerSupportDialog/components/CustomerSupportLog/components/ActivityLogCard';
import { ChannelSelector } from '@/components/widgets/CustomerSupport/components/CustomerSupportDialog/components/CustomerSupportLog/components/ChannelSelector';
import { getExistingChannelsInComments } from '@/components/widgets/CustomerSupport/utils/getExistingChannelsInComments';
import { PendingDataType } from '@/config/types';

interface CustomerSupportLogProps {
  ticketing: Ticketing;
}

export const CustomerSupportLog = ({ ticketing }: CustomerSupportLogProps) => {
  const existingChannels = getExistingChannelsInComments(ticketing.comments);
  const [selectedChannels, setSelectedChannels] = useState<string[]>(existingChannels);

  useEffect(() => {
    setSelectedChannels(existingChannels);
  }, [ticketing]);

  const filterTicketingBySelectedChannels = () =>
    ticketing.comments.filter((comment) => selectedChannels?.includes(comment.channel));

  const filteredComments = filterTicketingBySelectedChannels();

  return (
    <Box display={'flex'} width={'100%'} flexDirection={'column'} pt={2}>
      <Box display={'flex'} justifyContent={'space-between'}>
        <Font variant={'h4'} color={'secondary'} style={{ paddingBottom: '16px' }}>
          <Text strong tId={'ACTIVITY_LOG'} />
        </Font>
        {selectedChannels && (
          <ChannelSelector
            existingChannels={existingChannels}
            selectedChannels={selectedChannels}
            setSelectedChannels={setSelectedChannels}
          />
        )}
      </Box>
      {filteredComments.length > 0 ? (
        filteredComments.map((comment, i) => (
          <ActivityLogCard key={i} comments={filteredComments} comment={comment} index={i} />
        ))
      ) : (
        <>
          <PendingDataWarning type={PendingDataType.NO_CHANNELS_SELECTED} />
        </>
      )}
    </Box>
  );
};
